import React from "react";
import logo from "./assets/images/websiteLogo.png";
import location from "./assets/images/location.svg";
import call from "./assets/images/call.svg";
import sms from "./assets/images/sms.svg";
import facebook from "./assets/images/facebook.svg";
import instagram from "./assets/images/instagram.svg";
import youtube from "./assets/images/youtube.svg";

const Footer = () => {
  return (
    <div className="darkBlue py-[35px] text-[#D6D6D6]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">

        {/* Grid layout for responsiveness */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">

          {/* Logo & Contact Section */}
          <div className="max-w-[191px]">
            <div className="font-semibold flex items-center gap-2 pb-6">
              <img src={logo} alt="Logo" />
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex gap-2 items-center">
                <img src={location} alt="Location Icon" />
                <p className="text-sm">25566 Hc 1, Glenallen, Alaska, 99588, USA</p>
              </div>
              <div className="flex gap-2 items-center">
                <img src={call} alt="Call Icon" />
                <p className="text-sm">+123 4784 12345</p>
              </div>
              <div className="flex gap-2 items-center">
                <img src={sms} alt="Email Icon" />
                <p className="text-sm">Example@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Our Product Section */}
          <div>
            <h2 className="text-white pb-6 font-semibold">Our Product</h2>
            <ul className="flex flex-col gap-2">
              <li>Career</li>
              <li>Car</li>
              <li>Packages</li>
              <li>Features</li>
              <li>Priceline</li>
            </ul>
          </div>

          {/* Resources Section */}
          <div>
            <h2 className="text-white pb-6 font-semibold">Resources</h2>
            <ul className="flex flex-col gap-2">
              <li>Download</li>
              <li>Help Center</li>
              <li>Guides</li>
              <li>Partner Network</li>
              <li>Cruises</li>
              <li>Developer</li>
            </ul>
          </div>

          {/* About Cars Section */}
          <div>
            <h2 className="text-white pb-6 font-semibold">About Cars</h2>
            <ul className="flex flex-col gap-2">
              <li>Why choose us</li>
              <li>Our Story</li>
              <li>Investor Relations</li>
              <li>Press Center</li>
              <li>Advertise</li>
            </ul>
          </div>

          {/* Social Media Links */}
          <div>
            <h2 className="text-white pb-6 font-semibold">Follow Us</h2>
            <ul className="flex gap-4">
              <li><img src={facebook} alt="Facebook Icon" className="w-6 h-6" /></li>
              <li><img src={instagram} alt="Instagram Icon" className="w-6 h-6" /></li>
              <li><img src={youtube} alt="YouTube Icon" className="w-6 h-6" /></li>
            </ul>
          </div>

        </div>

        {/* Divider for spacing */}
        <div className="border-t border-gray-500 mt-8 pt-4 text-center text-sm">
          © {new Date().getFullYear()} Example. All rights reserved.
        </div>

      </div>
    </div>


  );
};

export default Footer;
